export default class Point {
  public constructor(
    public x = 0,
    public y = 0
  ) {}

  public copy(target: Point): void {
    this.x = target.x;
    this.y = target.y;
  }

  public copyTo(target: Point): void {
    target.x = this.x;
    target.y = this.y;
  }

  public angleTo(target: Point): number {
    return Math.atan2(this.y - target.y, this.x - target.x);
  }

  public distanceTo(target: Point): number {
    const x = this.x - target.x;
    const y = this.y - target.y;
    return Math.sqrt(x * x + y * y);
  }
}
